"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getErrorCode = exports.applyNormalizedFunctions = exports.handleErrors = exports.capitalizeFirstLetters = exports.toCamelCaseWithSpaces = exports.capitalizeFirstLetter = exports.convertFromEditableList = exports.convertToEditableList = exports.getOAuthState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _actions = require("./actions");

var _constants = require("./constants");

var _messagesI18n = require("./messages-i18n");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getOAuthState = function getOAuthState(state) {
  return state.get ? state.get(_constants.O_AUTH_STATE_KEY_NAME) : state[_constants.O_AUTH_STATE_KEY_NAME];
};

exports.getOAuthState = getOAuthState;

var convertToEditableList = function convertToEditableList(data) {
  return data && data.length > 0 ? data.map(function (d) {
    return {
      value: d
    };
  }) : [{}];
};

exports.convertToEditableList = convertToEditableList;

var convertFromEditableList = function convertFromEditableList(list) {
  return list.filter(function (l) {
    return !(0, _isEmpty.default)(l) && !(0, _isEmpty.default)(l.value);
  }).map(function (l) {
    return l.value;
  });
};

exports.convertFromEditableList = convertFromEditableList;

var capitalizeFirstLetter = function capitalizeFirstLetter(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

exports.capitalizeFirstLetter = capitalizeFirstLetter;

var toCamelCaseWithSpaces = function toCamelCaseWithSpaces(text) {
  return text.replace(/([-_][a-z])/gi, function ($1) {
    return $1.toUpperCase().replace('_', ' ');
  });
};

exports.toCamelCaseWithSpaces = toCamelCaseWithSpaces;

var capitalizeFirstLetters = function capitalizeFirstLetters(text) {
  return capitalizeFirstLetter(toCamelCaseWithSpaces(text));
}; // Basic error handling, shows all errors as toasts.


exports.capitalizeFirstLetters = capitalizeFirstLetters;

var handleErrors = function handleErrors(_ref, dispatch) {
  var errors = _ref.errors;
  errors.forEach(function (_ref2) {
    var message = _ref2.message;
    return (0, _actions.showErrorToastFactory)({
      title: _messagesI18n.messages.error,
      message: message
    })(dispatch);
  });
}; // Normalize data from given attributes with the given normalizeFunction


exports.handleErrors = handleErrors;

var applyNormalizedFunctions = function applyNormalizedFunctions(data, list) {
  var normalizedParams = list.reduce(function (acc, attribute) {
    var name = attribute.name,
        normalize = attribute.normalize;

    if (Object.prototype.hasOwnProperty.call(data, name)) {
      acc[name] = normalize(data[name]);
    }

    return acc;
  }, {});
  return _objectSpread(_objectSpread({}, data), normalizedParams);
}; // Return the code of the API error


exports.applyNormalizedFunctions = applyNormalizedFunctions;

var getErrorCode = function getErrorCode(error) {
  return error && error.detail && (error.detail.status || null);
};

exports.getErrorCode = getErrorCode;
//# sourceMappingURL=utils.js.map